<template>
  <component :is="icons[name]" :size="size" :stroke="2" :aria-hidden="label ? undefined : 'true'" :aria-label="label || undefined" :role="label ? 'img' : undefined" focusable="false" class="bs-icon" />
</template>
<script>
import { IconX, IconCopy, IconCheck, IconAlertCircle, IconArrowBackUp, IconChartBar, IconHistory, IconPlus, IconCreditCard,
  IconBrandFacebook, IconBrandTwitter, IconBrandTumblr, IconBrandPinterest, IconBrandReddit, IconMail } from '@tabler/icons-vue';

const icons = { close: IconX, copy: IconCopy, check: IconCheck, error: IconAlertCircle, undo: IconArrowBackUp,
  chart: IconChartBar, history: IconHistory, plus: IconPlus, billing: IconCreditCard,
  facebook: IconBrandFacebook, twitter: IconBrandTwitter, tumblr: IconBrandTumblr, pinterest: IconBrandPinterest, reddit: IconBrandReddit, mail: IconMail };
export default {
  props: {
    name: { type: String, required: true, validator: value => Object.hasOwn(icons, value) },
    label: { type: String, default: '' },
    size: { type: [Number, String], default: 20 }
  },
  setup: () => ({ icons })
};
</script>
